/* eslint no-unused-vars: 0 */

import React from "react"

class AdminSearchLivePreview extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      active: false
    };
    this.togglePreview = this.togglePreview.bind(this);
    this.viewLiveResults = this.viewLiveResults.bind(this);
  }

  viewLiveResults() {
    window.open(`/catalogue/products/search?q=${this.props.term}`, "_blank");
  }

  togglePreview() {
    var new_state = !this.state.active;
    this.setState({
      active: new_state
    });
  }

  render() {
    var toggleState =
      this.state.active === true ? (
        <i className="icon-chevron-down" />
      ) : (
        <i className="icon-chevron-up" />
      );
    return (
      <div
        className={
          "promoted--site-search live-preview " +
          (this.state.active === true ? "active" : "")
        }
      >
        <div className="container-fluid">
          <div className="row">
            <div className="span12">
              <h5>
                <button onClick={this.togglePreview} className="toggle">
                  {toggleState}
                </button>
                Order Preview
                <button
                  className="btn pull-right"
                  onClick={this.viewLiveResults}
                >
                  View Live Website
                </button>
              </h5>
            </div>
          </div>
          <div className="row">
            <div className="results">
              {this.props.results.map((result, index) => {
                var image =
                  result.promoted === true ? <i className="icon-ok" /> : "";
                return (
                  <div className="live-preview--product" key={index}>
                    <div
                      className={
                        "position" +
                        (result.promoted === true ? " promoted" : "")
                      }
                    >
                      Search Position: <strong>{index + 1}</strong>
                    </div>
                    {image}
                    <img src={result.image} />
                    <h5>{result.description_short}</h5>
                    <h6>
                      <strong>Step ID:</strong> {result.step_id}
                    </h6>
                    <h6>
                      <strong>Part Code:</strong> {result.part_code}
                    </h6>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AdminSearchLivePreview;
